import React from 'react'
import HeroTwo from '../components/heroTwo/HeroTwo';
import img from '../assets/course-bg.png';

export default function Payment() {
    return (
        <div>
                <HeroTwo 
         head='Payment Page'
         image={img}
         bgposition='top'
         bgsize='contain'
         />
        </div>
    )
}
